class OTFControlSlider {
    constructor() {
        $('.otf-customize-slider .otf-slider').each((index, element) => {
            this.initSlider(element);
        })
    }

    initSlider(element) {
        let $slider = $(element);
        let id      = $slider.data('id');
        let unit    = $slider.data('unit') ? $slider.data('unit') : '';
        $slider.slider({
            range : "min",
            min   : $slider.data('min'),
            max   : $slider.data('max'),
            step  : $slider.data('step'),
            value : $slider.data('value'),
            create: function (event, ui) {
                $slider.children('.ui-slider-handle').html(`<span>${$slider.slider('value')}${unit}</span>`);
            },
            slide : function (event, ui) {
                $slider.children('.ui-slider-handle').html(`<span>${ui.value}${unit}</span>`);
                wp.customize.control(id).setting.set(ui.value)
            },
            change: function (event, ui) {
                $slider.children('.ui-slider-handle').html(`<span>${ui.value}${unit}</span>`);
                wp.customize.control(id).setting.set(ui.value);
            }
        });

        $slider.next().on('click', function () {
            $slider.slider('value', $slider.data('default-value'));
        })
    }


}